// File validation utilities
const VALID_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'text/markdown',
];

const VALID_EXTENSIONS = ['.pdf', '.docx', '.txt', '.md'];

export function isValidFileType(file) {
  return (
    VALID_TYPES.includes(file.type) ||
    VALID_EXTENSIONS.some((ext) => file.name.toLowerCase().endsWith(ext))
  );
}

export function showError(message) {
  alert(message);
  console.error(message);
}
